const ListingPage = (function () {
  const $listingArea = $("#listing-area");
  const $listingPage = $("#listing-page");

  const $dropdownFilterNewsType = $("#filter-news-type");
  const $dropdownFilterCategories = $("#filter-category");
  const $dropdownFilterAuthors = $("#filter-author");
  const $dropdownFilterYears = $("#filter-year");
  const $checkboxFilterRegulatory = $("#filter-regulatory");
  const $dropdownOrderBy = $("#order-by");

  const $addMoreItemsToList = $(".js-add-more-items-to-list");
  const $loadSpinnerTop = $("#load-spinner-top");
  const $loadSpinnerBottom = $("#load-spinner-bottom");
  const $btnShowMore = $(".js-show-more-listing-items");
  const $noMoreResultMessage = $(".js-no-more-result-message");

  const filterCategoryDataAttribute = "filter-category";
  const filterAuthorDataAttribute = "filter-author";
  const filterYearDataAttribute = "filter-year";
  const filterRegulatoryDataAttribute = "filter-regulatory";
  const searchQueryDataAttrbiute = "search-query";
  const orderByDataAttrbiute = "order-by";

  const isNewsListingPage = $listingPage.hasClass("news-listing-page");
  const isFrontifyListingPage = $listingPage.hasClass("frontify-listing-page");
  const isCalendarListingPage = $listingPage.hasClass("calendar-listing-page");
  const isSearchPage = $listingPage.hasClass("search-page");

  let requestPending = false;
  let fetchMorePagesCount: number = 1;

  function init() {
    $(document).ready(function () {
      hideAndShowWithAnimation($loadSpinnerTop, $listingArea);
    });

    if (isNewsListingPage) {
      handleDropDownNewsType();
      handleDropDownCategories();
      handleDropDownAuthors();
      handleDropDownYears();
      handleCheckboxRegulatory();
    } else if (isFrontifyListingPage) {
      handleDropDownCategories();
    } else if (isSearchPage) {
      handleDropDownOrderBy();
    }

    const url = new URL(window.location.href);
    const currentPage = url.searchParams.get("page");
    history.pushState({}, "", url);
    if (currentPage) fetchMorePagesCount = Number(currentPage);

    $btnShowMore.on("click", function () {
      if ($(this).is(":disabled") || requestPending) {
        return;
      }
      if (isNewsListingPage) {
        fetchMoreItems("GetMorePages");
      } else if (isFrontifyListingPage) {
        fetchMoreItems("GetMoreQbankMedia");
      } else if (isCalendarListingPage) {
        fetchMoreItems("GetMorePreviousEvents");
      } else if (isSearchPage) {
        fetchMoreItems("GetMoreSearchHits");
      }
    });
  }

  function updateHistory(page: number) {
    if (isNewsListingPage) {
      const url = new URL(window.location.href);
      url.searchParams.set("page", page.toString());
      url.searchParams.set("all", "true");
      window.history.pushState(null, "", url.toString());
    }
  }

  function handleDropDownNewsType() {
    $dropdownFilterNewsType.on("change", function () {
      reloadPageWithAnimation($dropdownFilterNewsType.val() as string);
    });
  }

  function handleDropDownCategories() {
    $dropdownFilterCategories.on("change", function () {
      $listingPage.data(
        filterCategoryDataAttribute,
        $dropdownFilterCategories.val() as string,
      );
      reloadPageWithAnimation(getFilterUrl());
    });
  }

  function handleDropDownAuthors() {
    $dropdownFilterAuthors.on("change", function () {
      $listingPage.data(
        filterAuthorDataAttribute,
        $dropdownFilterAuthors.val() as string,
      );
      reloadPageWithAnimation(getFilterUrl());
    });
  }

  function handleDropDownYears() {
    $dropdownFilterYears.on("change", function () {
      $listingPage.data(
        filterYearDataAttribute,
        $dropdownFilterYears.val() as string,
      );
      reloadPageWithAnimation(getFilterUrl());
    });
  }

  function handleCheckboxRegulatory() {
    $checkboxFilterRegulatory.on("change", function () {
      $listingPage.data(
        filterRegulatoryDataAttribute,
        $checkboxFilterRegulatory.is(":checked"),
      );
      reloadPageWithAnimation(getFilterUrl());
    });
  }

  function handleDropDownOrderBy() {
    $dropdownOrderBy.on("change", function () {
      $listingPage.data(orderByDataAttrbiute, $dropdownOrderBy.val() as string);
      reloadPageWithAnimation(getFilterUrl());
    });
  }

  function reloadPageWithAnimation(url: string) {
    hideAndShowWithAnimation($listingArea, $loadSpinnerTop);
    if (!url || url.length === 0) {
      url = window.location.pathname;
    }
    $(location).attr("href", url);
  }

  function hideAndShowWithAnimation(
    hideElement: JQuery<HTMLElement>,
    showElement: JQuery<HTMLElement>,
    animationTime = 500,
  ) {
    hideElement
      .animate(
        {
          opacity: 0,
        },
        animationTime,
        function () {
          showElement
            .animate(
              {
                opacity: 1,
              },
              animationTime,
            )
            .css("visibility", "visible");
        },
      )
      .css("visibility", "hidden");
  }

  function fetchMoreItems(actionResName: string) {
    requestPending = true;
    hideAndShowWithAnimation($btnShowMore, $loadSpinnerBottom, 0);

    fetchMorePagesCount = fetchMorePagesCount + 1;
    const fetchMorePagesUrl = getFetchMoreUrl(
      actionResName,
      fetchMorePagesCount,
    );

    $.ajax({
      url: fetchMorePagesUrl,
      dataType: "html",
      success: function (newItems) {
        $(newItems)
          .appendTo($listingArea.find($addMoreItemsToList))
          .hide()
          .fadeIn(1000);

        const noMoreFetches =
          $(newItems).filter(".js-last-listing-item").length ||
          newItems.trim().length === 0;
        if (noMoreFetches) {
          $btnShowMore.prop("disabled", true).addClass("hide-button");
          $noMoreResultMessage.show();
        }
        updateHistory(fetchMorePagesCount);
      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log(xhr.status);
        console.log(thrownError);
      },
    }).always(function () {
      hideAndShowWithAnimation($loadSpinnerBottom, $btnShowMore, 150);
      requestPending = false;
    });
  }

  function getFilterUrl() {
    const queryParameters = getQueryParametersUrl();
    return queryParameters.length > 0 ? queryParameters.replace("&", "?") : "";
  }

  function getFetchMoreUrl(actionResName: string, fetchMorePagescount: number) {
    const pageId = $listingPage.data("page-id");
    return (
      actionResName +
      "?id=" +
      pageId +
      getQueryParametersUrl() +
      "&page=" +
      fetchMorePagescount
    );
  }

  function getQueryParametersUrl() {
    const category = $listingPage.data(filterCategoryDataAttribute);
    const filter = $listingPage.data(filterCategoryDataAttribute);
    const author = $listingPage.data(filterAuthorDataAttribute);
    const year = $listingPage.data(filterYearDataAttribute);
    const regulatory = $listingPage.data(filterRegulatoryDataAttribute);
    const query = $listingPage.data(searchQueryDataAttrbiute);
    const orderby = $listingPage.data(orderByDataAttrbiute);

    return (
      (category && category > 0 ? "&category=" + category : "") +
      (filter ? "&f=" + filter : "") +
      (author && author > 0 ? "&author=" + author : "") +
      (year && year > 0 ? "&year=" + year : "") +
      (regulatory && (regulatory === true || regulatory === "True")
        ? "&regulatory=" + regulatory
        : "") +
      (query && query.length > 0 ? "&query=" + query : "") +
      (orderby && orderby.length > 0 ? "&orderby=" + orderby : "")
    );
  }

  return {
    init,
  };
})();

export default ListingPage;
